import React, { Component } from 'react';
import TaskList from "../../../components/TaskList";
import {getTasksForForm, getIpsLocationsForForm, getPreform} from "../../../api/PreEForm";
import { Breadcrumb } from "antd";
import {Link, withRouter} from "react-router-dom";
import PageTitle from "../../../components/PageTitle";
import {updateTasks} from "../../../api";
import TaskStatus from "../../Tasks/TaskStatus";
import ShowPreEExceptionDialog from "../PreEExceptionDialog";
import {Row} from "react-flexbox-grid";
import Spinner, {spinnerOff, spinnerOn} from "../../../components/Spinner";
import InvalidDataConfirm from "../../../components/ConfirmPopUp";
import PreETaskListItem from "../../../components/PreETaskListItem";



class PreEFormTasks extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.updateTaskStatus = this.updateTaskStatus.bind(this);
    }

    state = {
        form : null,
        ipsLocations : [],
        tasks : [],
    };

    async componentDidMount() {
        spinnerOn();
        this._isMounted = true;

        const { projectId } = this.props;
        const { formId } = this.props.match.params;
        const form = await getPreform(projectId, formId);

        const ipsLocations = await getIpsLocationsForForm(projectId, formId);
       const tasks = await getTasksForForm(projectId, formId);
        if (this._isMounted) {
            this.setState({form, ipsLocations, tasks, formId});
            spinnerOff();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async updateTaskStatus(statusId, selectedTasks) {
        try {
            const { projectId } = this.props;
            const updatedTasks = selectedTasks.map(task => ({ ...task, ...{ statusId }}));
            let preTasksUpdated = await updateTasks(updatedTasks);
            if(preTasksUpdated.updated === true){
                InvalidDataConfirm();
            }
            const formId = this.props.match.params.formId;
            const tasks = await getTasksForForm(projectId, formId);
            this.setState({ tasks });
        } catch (err) {
            console.log(err)
        }
    }

    onCreateForm = (props) => {
        ShowPreEExceptionDialog(props);
    };

    render() {
        const { projectId, status, projectStatus, project } = this.props;
        const { ipsLocations, tasks } = this.state;

        return (
            <>
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <Link to={`/${status}/${projectId}/peform`} onClick={this.props.updateFormState} style={{fontize: "30px"}}> Pre-energization Form List</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        { this.state.form && this.state.form.formName}
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Spinner/>

                <PageTitle title={ 'Pre-Energization Tasks' } />
                <div style={{ float: 'right' }}>
                    <strong>Task Version #: </strong>{(tasks[0]?.revisionNo) ? ('Rev ' + tasks[0]?.revisionNo) : ('N/A')}
                </div>
                <div>
                    <strong>Energization Date:</strong> { this.state.form && this.state.form.preEnergizationDate}<br/>
                    <strong>REQ#:</strong> { this.state.form && this.state.form.reqSos}
                </div>
                    <PreETaskListItem projectId={projectId} project={project} status={status} ipsLocations={ipsLocations}/>
                <TaskList tasks={tasks}
                          projectStatus={projectStatus}
                    onSignHandler={(tasks) => this.updateTaskStatus(TaskStatus.SIGNED,tasks)}
                    onRequestSignatureHandler={(task) => this.updateTaskStatus(TaskStatus.REQUESTED, task)}
                    onMarkNaHandler={(task) => this.updateTaskStatus(TaskStatus.NA, task)}
                    onMarkTempHandler={(task) => this.updateTaskStatus(TaskStatus.TEMPORARY, task)}
                    onUndoHandler={(task) => this.updateTaskStatus(TaskStatus.UNDO, task)}
                />
            </>
        )
    }
}

export default withRouter(PreEFormTasks);